import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import './Dashboard.css';

const MySessions = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sessions, setSessions] = useState([]);
  const { user } = useAuth();

  useEffect(() => {
    // TODO: Implement session data fetching
    const fetchMySessions = async () => {
      try {
        setLoading(true);
        // const data = await sessionService.getMySessions();
        // setSessions(data);
        setError(null);
      } catch (err) {
        setError('Failed to fetch sessions. Please try again later.');
        console.error('Error fetching sessions:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchMySessions();
  }, []);

  if (loading) {
    return (
      <div className="dashboard-loading">
        <div className="spinner"></div>
        <p>Loading your sessions...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="dashboard-error">
        <div className="error-content">
          <i className="error-icon fas fa-exclamation-circle"></i>
          <h2>Error Loading Sessions</h2>
          <p>{error}</p>
          <button className="retry-button" onClick={() => window.location.reload()}>
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>My Sessions</h1>
        {user.role === 'student' && (
          <button className="btn btn-primary">
            <i className="fas fa-plus"></i> Book New Session
          </button>
        )}
      </div>

      <div className="dashboard-content">
        <div className="filters-section">
          <div className="search-box">
            <i className="fas fa-search"></i>
            <input type="text" placeholder="Search sessions..." />
          </div>
          <div className="filter-options">
            <select defaultValue="">
              <option value="">All Status</option>
              <option value="upcoming">Upcoming</option>
              <option value="completed">Completed</option>
              <option value="cancelled">Cancelled</option>
            </select>
            <input type="date" placeholder="Filter by date" />
          </div>
        </div>

        <div className="sessions-grid">
          {sessions.length === 0 ? (
            <div className="no-data">
              <i className="fas fa-calendar-alt"></i>
              <h2>No Sessions Found</h2>
              <p>
                {user.role === 'student' 
                  ? 'Book your first counselling session'
                  : 'No sessions scheduled yet'
                }
              </p>
              {user.role === 'student' && (
                <button className="btn btn-primary">
                  Browse Available Sessions
                </button>
              )}
            </div>
          ) : (
            sessions.map(session => (
              <div key={session.id} className="session-card">
                <div className="session-header">
                  <div className="session-info">
                    <h3>{session.title}</h3>
                    <p>
                      <i className="fas fa-clock"></i>
                      {session.duration} minutes
                    </p>
                  </div>
                  {session.status === 'upcoming' && (
                    <div className="countdown">
                      <i className="fas fa-hourglass-half"></i>
                      Starts in {session.timeUntilStart}
                    </div>
                  )}
                </div>

                <div className="session-details">
                  <p>
                    <i className="fas fa-calendar"></i>
                    {session.date}
                  </p>
                  <p>
                    <i className="fas fa-user"></i>
                    {user.role === 'student' ? session.counsellorName : session.studentName}
                  </p>
                  <p>
                    <i className="fas fa-tag"></i>
                    {session.topic}
                  </p>
                </div>

                <div className="session-footer">
                  <span className={`status-badge ${session.status.toLowerCase()}`}>
                    {session.status}
                  </span>
                  <div className="session-actions">
                    {session.status === 'upcoming' && (
                      <>
                        <button className="join-session-btn">
                          Join Session
                          <i className="fas fa-video"></i>
                        </button>
                        {user.role === 'student' && (
                          <button className="cancel-btn">
                            Cancel
                            <i className="fas fa-times"></i>
                          </button>
                        )}
                      </>
                    )}
                    {session.status === 'completed' && (
                      <button className="feedback-btn">
                        {user.role === 'student' ? 'Give Feedback' : 'View Feedback'}
                        <i className="fas fa-star"></i>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default MySessions; 